


























import { Object } from 'lodash'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import {IUser} from '@/store/modules/views/user/states'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { ICenter } from '@/store/modules/views/center/states'

@Component
export default class IncomeCenter extends VueExtendedBaseComponent {
  private options: OptionTable = {
    page: 1,
    sortBy: ['users.userDetail.firstname'],
    sortDesc: [true],
    itemsPerPage: 10,
    search: '',
  }
  private queryParams = {
    startDate: '',
    endDate: '',
  }
  private id = ''
  private name = ''
  private email = ''
  private currentData = {}
  private filters = {}
  private loadingDataTable = true
  private createDialog = false
  private editDialog = false
  private deleteDialog = false
  private resetDialog = false
  private clearTimeoutValue: NodeJS.Timeout = setTimeout(() => undefined, 100)

  get headers(): Array<{ text: string; value: string }> {
    return this.headerLists
  }

  get items() {
    return this.itemLists
  }

  get paginationLists() {
    return this.pagination
  }

  @Action('report/initList')
  private initList!: () => void

  @Action('report/getIncomeCenterList')
  private getListApi!: (headerParams: {
    params: {}
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Getter('center/centerById')
  private centerById!: {[centerId: string]: ICenter}

  @Getter('role/roleById')
  private roleById!: {[roleId: string]: ICenter}

  @Getter('report/headers')
  private headerLists!: Array<{ text: string; value: string }>

  @Getter('report/itemLists')
  private itemLists!: () => void

  @Getter('report/pagination')
  private pagination!: () => void

  private async getList() {
    this.loadingDataTable = true
    await this.getListApi({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: _.get(this.options, 'sortBy[0]', 'createdAt'),
        sortDesc: _.get(this.options, 'sortDesc[0]', true),
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify(this.filters)).toString('base64'),
      },
      params: _.omitBy(this.queryParams, _.isEmpty),
    })
    this.loadingDataTable = false
  }
  private mapAddressText(text: IUser['address']) {
      return this.mapAddress(text)
  }

  private doGetLists() {
    clearTimeout(this.clearTimeoutValue)
    this.loadingDataTable = true
    this.clearTimeoutValue = setTimeout(this.getList, 1000)
  }

  private openDialog( user: {name: string, email: string, id: string}, modelDialog: 'editDialog' | 'resetDialog' | 'deleteDialog') {
    this.currentData = _.cloneDeep(user)
    this[modelDialog] = true
  }

  private addNewLeaderDialog() {
    this.createDialog = true
  }

  private async created() {
    await this.initList()
    await this.getList()
  }
}
